import { IMapper } from '@/mappers/index'
import {
  ICreateEmployee,
  ICreateEmployeeResponse,
  IEmployee,
  IEmployeeResponse, IEmployeeRoles,
  IEmployeeRolesResponse
} from '@/types/employees'

export const employeeRolesMap: IMapper<IEmployeeRolesResponse, IEmployeeRoles> = {
  name: 'name',
  description: 'description'
}
export const employeesMap: IMapper<IEmployeeResponse, IEmployee> = {
  id: 'id',
  user_id: 'userId',
  name: 'name',
  email: 'email',
  position: 'position',
  roles: ['roles', employeeRolesMap]
}

export const createEmployeeMap: IMapper<ICreateEmployeeResponse, ICreateEmployee> = {
  moid: 'moid',
  name: 'name',
  email: 'email',
  password: 'password',
  position: 'position',
  roles: 'roles'
}
